import Hero from "@/components/Hero";
import BrandIntro from "@/components/BrandIntro";
import Marquee from "@/components/Marquee";
import Impact from "@/components/Impact";
import WhyOrganizations from "@/components/WhyOrganizations";
import Solutions from "@/components/Solutions";
import Featured from "@/components/Featured";

const Home = () => (
  <>
    <Hero />
    <BrandIntro />
    <Marquee />
    <Impact />
    <WhyOrganizations />
    <Solutions />
    <Featured />
  </>
);

export default Home;
